import React from 'react';
import PropTypes from 'prop-types';

function CustomBlock({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12.712 3.175l6.4 3.344c.267.138.49.352.648.616.157.264.24.57.24.88v7.968c0 .31-.083.616-.24.88a1.628 1.628 0 01-.648.616l-6.4 3.344a1.543 1.543 0 01-1.432 0l-6.4-3.344a1.63 1.63 0 01-.645-.621A1.729 1.729 0 014 15.974V8.015c0-.31.083-.616.24-.88.157-.264.381-.478.648-.616l6.4-3.344a1.544 1.544 0 011.424 0z"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 7.5l7.5 4 7.5-4M12 21v-9.5" />
    </svg>
  );
}

CustomBlock.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default CustomBlock;
